import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-desktopAppPage',
  templateUrl: './desktopAppPage.component.html',
  styleUrls: ['./desktopAppPage.component.scss']
})
export class DesktopAppPageComponent implements OnInit {
  download = false;
  path: any;
  os: any;
  loginDetails;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
  ) { 
    this.loginDetails = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
  }
  downloadingPath(path, os): void {
    this.path = '../' + path;

    if (this.path.search('/linux') !== -1) {
      this.os = 'linux';

    } else if (this.path.search('/windows') !== -1) {
      this.os = 'windows';

    } else {
      this.os = 'mac';
    }
  }

  loginPage(): void {
    this.router.navigate(['/login']);
    this.toastr.info('Login To The Desktop App At First.');
    this.toastr.success('Desktop Application Downloaded Successfully');
  }

  goBackLocation() {
    this.router.navigate(['/login']);
  }

  skipDownloadDesktop() {
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.sessiontoken, this.loginDetails.myObject.sessionToken);
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.tenantId, this.loginDetails.myObject.tenantId);

    this.queryInterface.executeQueryWithRelation(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'objectId', value: this.loginDetails.myObject.profile.objectId },
      { condition: 'include', value: 'role' }, { condition: 'include', value: 'department' }]).then(async results => {
        const result = results[0];
        const jsonText = JSON.stringify(result);
        const profile = JSON.parse(jsonText);
        const roleName = profile.role.name;
        const deptName = profile.department.name;


        if (roleName == 'CEO' || roleName == 'General Manager' || roleName == 'HR' || roleName == 'Admin' || deptName == 'Management') {
          this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Admin');
        }
        else if ((roleName == 'Project Manager' || roleName == 'QA Lead' || roleName == 'Leader') && deptName != 'Management') {
          this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Leader');
        }
        else if (roleName == 'IT Manager' && deptName != 'Management') {
          this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'IT Manager');
        }
        else {
          this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Employee');
        }
        this.storageConfiguration.sessionSetItem(this.storageConfiguration.isloggedIn, 'true');
        if (this.loginDetails.isDefaultAuth) {
          this.toastr.success('Still using default Opnworx Password');
          this.router.navigate(['reset-password']);
        } else{
          this.router.navigate(['/todo-list-item']);
        }
      });

  }

}
